export default __webpack_public_path__ + "static/media/Condiciones_generales_ordinario_2026_modificado.bc7ace1c.pdf";